<div class="changelog-dialog">
  <!-- Current Version Badge -->
  <div class="current-version-banner">
    <div class="banner-content">
      <span class="banner-icon">🎉</span>
      <div class="banner-text">
        <strong>Versione Attuale</strong>
        <span class="version-tag">v{{ currentVersion }}</span>
      </div>
      <span class="env-badge">{{ environmentName }}</span>
    </div>
  </div>

  <!-- Changelog Content -->
  <div class="changelog-content">
    <div class="changelog-list">
      <div
        *ngFor="let entry of changelog; let i = index"
        class="changelog-entry"
        [class.current]="isCurrentVersion(entry.version)">

        <!-- Version Header -->
        <div class="entry-header">
          <div class="version-info">
            <h3 class="version-number">
              <span class="version-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
                  <path d="M12 6v6l4 2" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                </svg>
              </span>
              {{ entry.version }}
            </h3>
            <span class="version-date">{{ entry.date }}</span>
          </div>
          <div class="current-badge" *ngIf="isCurrentVersion(entry.version)">
            <i class="pi pi-star-fill"></i>
            Attuale
          </div>
        </div>

        <!-- Sections -->
        <div class="entry-sections">
          <div *ngFor="let section of entry.sections" class="section">
            <div class="section-header" [style.borderColor]="section.color">
              <span class="section-icon">{{ section.icon }}</span>
              <h4 class="section-title" [style.color]="section.color">{{ section.title }}</h4>
            </div>
            <ul class="section-items">
              <li *ngFor="let item of section.items">
                <span class="item-bullet" [style.backgroundColor]="section.color"></span>
                <span class="item-text">{{ item }}</span>
              </li>
            </ul>
          </div>
        </div>

        <!-- Divider -->
        <p-divider *ngIf="i < changelog.length - 1"></p-divider>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="changelog-footer">
  <!--   <div class="footer-info">
      <i class="pi pi-info-circle"></i>
      <span>Per i dettagli completi, consulta il changelog su Git</span>
    </div> -->
    <button
      pButton
      type="button"
      label="Scarica Changelog"
      icon="pi pi-download"
      class="p-button-outlined"
      (click)="downloadChangelog()">
    </button>
  </div>
</div>

